<div class="popupStyles" *ngIf="showPopup">
  <div class="row innerModal">
      <div class="closeIcon mt-2 px-3 py-3">
        <i class="fa fa-times" (click)="closePopup()"></i>
      </div>
    
    <p *ngIf="modalData.title" class="modal-title">{{ modalData.title }}</p>
    <div class="modal-body">
      <p>{{ modalData.message }}</p>
    </div>
    <div class="modal-footer" *ngIf="modalData.confirmationButtons">
      <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
      >
        Yes
      </button>
      <button type="button" class="btn btn-primary" >
        No
      </button>
    </div>
  </div>
</div>
